<template>
  <DragDialog
    title="导出"
    :width="1150"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="proj-name-box">
      <div class="label-box dialog-label">项目名称：</div>
      <div class="common-select-box">
        <el-select
          class="primary-select"
          size="small"
          filterable
          remote
          clearable
          :remote-method="filterProj"
          :loading="filterProjLoading"
          placeholder="请选择导出项目"
          v-model="projId"
          :popper-append-to-body="false"
          @change="handleProjChange">
          <template slot="prefix">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search" />
          </template>
          <el-option
            v-for="(item, index) in projList"
            :key="index"
            :title="item.projectName"
            :label="item.projectName"
            :value="item.projectId" />
        </el-select>
      </div>
    </div>
    <div class="export-content-box">
      <div class="export-type-box">
        <div
          :class="getExportTypeClass('exportDataSet')"
          @click="switchExportType('exportDataSet')">
          导出数据集
        </div>
        <div
          :class="getExportTypeClass('exportScene')"
          @click="switchExportType('exportScene')">
          导出场景
        </div>
      </div>
      <div class="split-line" />
      <div class="export-data-box">
        <DataSetExport
          v-if="currExportType === 'exportDataSet'"
          ref="dataSetExport"
          :projId="projId" />
        <SceneExport
          v-if="currExportType === 'exportScene'"
          ref="sceneExport"
          :projId="projId" />
      </div>
    </div>
    <div class="footer-box common-button-box">
      <el-button
        class="primary-btn primary-ang-btn"
        v-if="currExportType === 'exportDataSet'"
        type="primary"
        size="small"
        @click="exportDataSet">
        导出数据集
      </el-button>
      <el-button
        class="primary-btn primary-ang-btn"
        v-if="currExportType === 'exportScene'"
        type="primary"
        size="small"
        @click="exportScene">
        导出场景
      </el-button>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import DataSetExport from './DataSetExport.vue'
import SceneExport from './SceneExport.vue'

import { Store } from '@/utils/store'

import {
  getExportOptionalProjListService,
  offlineDataSetExportCheckService,
  offlineSceneExportCheckService
} from '@/service/interface'

export default {
  data() {
    return {
      filterProjLoading: false,
      filterProjName: '',
      projList: [],
      projId: '',
      currExportType: 'exportDataSet',

      dataSetsToExport: [],
      scenesToExport: []
    }
  },
  props: {
    visible: Boolean,
    openSetvalidityDialog: Function,
    closeDialog: Function
  },
  components: {
    DragDialog,
    DataSetExport,
    SceneExport
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initProjList()
      }
    }
  },
  methods: {
    handleProjChange() {
      if (!this.projId) {
        this.initProjList()
      }
      this.$nextTick(() => {
        this.updateExportList()
      })
    },
    cancel() {
      this.clearData()
      this.closeDialog()
    },
    getExportTypeClass(exportType) {
      let className = 'type-item-box'
      if (this.currExportType === exportType) {
        className += ' active-item'
      }
      return className
    },
    switchExportType(exportType) {
      this.currExportType = exportType
      if (this.projId) {
        this.$nextTick(() => {
          this.updateExportList()
        })
      }
    },
    updateExportList() {
      if (this.currExportType === 'exportDataSet') {
        let domRef = this.$refs.dataSetExport
        domRef.updateDataSetList()
      } else {
        let domRef = this.$refs.sceneExport
        domRef.updateSceneList()
      }
    },
    exportDataSet() {
      if (!this.projId) {
        this.$message.warning('请先选择项目')
        return
      }

      let domRef = this.$refs.dataSetExport
      let exportDataSetInfo = domRef.getExportDataSetInfo()
      let dataSets = exportDataSetInfo.dataSets
      if (!dataSets.length) {
        this.$message.warning('请选择需要导出的数据集')
        return
      }

      this.exportDataSetCheck(exportDataSetInfo).then(isCheckPass => {
        if (isCheckPass) {
          this.openSetvalidityDialog('exportDataSet')
        }
      })
    },
    exportDataSetCheck(exportDataSetInfo) {
      return new Promise(resolve => {
        let { scheme, dataSets } = exportDataSetInfo
        let dataSetIds = dataSets.map(el => el.id)
        let items = [{ scheme, dataSetIds }]
        let params = { items }
        offlineDataSetExportCheckService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let isCheckPass = data.checkResult
            if (isCheckPass) {
              this.dataSetsToExport = dataSets
              resolve(isCheckPass)
            } else {
              // prettier-ignore
              let exceptioDataSets = this.getExceptioDataSets(data.unEffectiveItems);
              if (exceptioDataSets.length === dataSets.length) {
                let warningMsg = '所选数据集均正在导出'
                this.$confirm(warningMsg, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  this.dataSetsToExport = []
                  resolve(false)
                })
              } else {
                // prettier-ignore
                let warningMsg = "所选数据集包含正在导出的，是否跳过，继续导出其余数据集";
                this.$confirm(warningMsg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  exceptioDataSets.forEach(item => {
                    let findIndex = dataSets.find(
                      el => el.id === item.dataSetId
                    )
                    dataSets.splice(findIndex, 1)
                  })
                  this.dataSetsToExport = dataSets
                  resolve(true)
                })
              }
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getExceptioDataSets(unEffectiveItems) {
      let exceptioDataSets = []
      unEffectiveItems.forEach(item => {
        let items = item.items
        items.forEach(dataSet => {
          let obj = {
            dataSetId: dataSet.id,
            dataSetName: dataSet.name,
            scheme: dataSet.scheme,
            status: item.status
          }
          exceptioDataSets.push(obj)
        })
      })
      return exceptioDataSets
    },
    exportScene() {
      if (!this.projId) {
        this.$message.warning('请先选择项目')
        return
      }

      let domRef = this.$refs.sceneExport
      let exportSceneInfo = domRef.getExportSceneInfo()
      let scenes = exportSceneInfo.scenes
      if (!scenes.length) {
        this.$message.warning('请选择需要导出的场景')
        return
      }

      this.exportSceneCheck(exportSceneInfo).then(isCheckPass => {
        if (isCheckPass) {
          this.openSetvalidityDialog('exportScene')
        }
      })
    },
    exportSceneCheck(exportSceneInfo) {
      return new Promise(resolve => {
        let { scenes } = exportSceneInfo
        let sceneIds = scenes.map(el => el.sceneId)
        let params = { projId: this.projId, sceneIds }
        offlineSceneExportCheckService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (!data.unEffectiveItems.length) {
              this.scenesToExport = scenes
              resolve(true)
            } else {
              // prettier-ignore
              let exceptioScenes = this.getExceptioScenes(data.unEffectiveItems);
              if (exceptioScenes.length === scenes.length) {
                let warningMsg = '所选场景均正在导出'
                this.$confirm(warningMsg, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  this.scenesToExport = []
                  resolve(false)
                })
              } else {
                // prettier-ignore
                let warningMsg = "所选场景包含正在导出的，是否跳过，继续导出其余场景";
                this.$confirm(warningMsg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  exceptioScenes.forEach(item => {
                    let findIndex = scenes.find(el => el.id === item.sceneId)
                    scenes.splice(findIndex, 1)
                  })
                  this.scenesToExport = scenes
                  resolve(true)
                })
              }
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getExceptioScenes(unEffectiveItems) {
      let exceptioScenes = []
      unEffectiveItems.forEach(item => {
        let items = item.items
        items.forEach(scene => {
          let obj = {
            sceneId: scene.id,
            sceneName: scene.name,
            status: item.status
          }
          exceptioScenes.push(obj)
        })
      })
      return exceptioScenes
    },
    getExportInfo() {
      let exportInfo = { projId: this.projId }
      if (this.currExportType === 'exportDataSet') {
        let domRef = this.$refs.dataSetExport
        let exportDataSetInfo = domRef.getExportDataSetInfo()
        let { scheme } = exportDataSetInfo
        let dataSetIds = this.dataSetsToExport.map(el => el.id)
        let items = [{ scheme, dataSetIds }]
        exportInfo.exportType = 'DataSet'
        exportInfo.items = items
      } else {
        let sceneIds = this.scenesToExport.map(el => el.sceneId)
        exportInfo.exportType = 'Scene'
        exportInfo.sceneIds = sceneIds
      }
      return exportInfo
    },
    initProjList() {
      getExportOptionalProjListService({}).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    filterProj(filterName) {
      this.filterProjName = filterName
      this.filterProjLoading = true
      getExportOptionalProjListService({ projectName: filterName }).then(
        response => {
          if (response.isSuccess) {
            let projList = response.data
            this.projList = projList
            this.filterProjLoading = false
          } else {
            this.$message.error(response.errMsg)
          }
        }
      )
    },
    clearData() {
      this.filterProjName = ''
      this.projList = []
      this.projId = ''
      this.currExportType = 'exportDataSet'

      this.dataSetsToExport = []
      this.scenesToExport = []
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.proj-name-box {
  display: flex;
  color: var(--default-color);

  .label-box {
    width: 150px;
    text-align: center;
    line-height: 32px;

    &::before {
      content: '*';
      color: var(--error-status-color);
      margin-right: 5px;
    }
  }

  .common-select-box {
    width: 240px;

    .el-select {
      width: 100%;
    }
  }
}

.export-content-box {
  display: flex;
  height: 600px;
  margin-top: 16px;
  font-size: 14px;
  color: var(--default-color);
  border-top: 1px solid var(--dialog-footer-border-color);

  .export-type-box {
    min-width: 150px;
    padding: 10px;
    padding-left: 0px;

    .type-item-box {
      margin: 10px 0px;
      padding: 8px 30px;
      text-align: center;
      background: var(--migration-dataExport-tab-item-bgColor);
      font-weight: 400;
      color: var(--migration-dataExport-tab-item-text-color);
      cursor: pointer;
      border-radius: 6px;

      &:hover {
        background-color: var(--migration-dataExport-tab-item-hover-bgColor);
        border-radius: 6px;
      }

      &:first-child {
        margin-top: 0px;
      }
    }

    .active-item {
      color: var(--base-primary-bgColor);
      background-color: var(--base-bg-light-color24) !important;
    }
  }

  .split-line {
    width: 1px;
    flex-shrink: 0;
    height: 100%;
    background: var(--tabs-card-header-border-color);
  }

  .export-data-box {
    flex-grow: 1;
    padding: 10px;
    overflow: hidden;
  }
}

.footer-box {
  width: calc(100% + 30px);
  margin-left: -15px;
  padding: 15px 10px 0px 10px;
  border-top: 1px solid var(--dialog-footer-border-color);
  text-align: right;
}
</style>
